import React from "react";

/**
 * TenantStatusBadge — Badge visual para status de tenants.
 *
 * @param {boolean} active - se o tenant está ativo
 * @param {string} trialStartDate - ISO date do inicio do trial (ou null)
 * @param {string} trialEndsAt - ISO date do fim do trial (ou null)
 * @param {string} accessBlockedAt - ISO date do bloqueio (ou null)
 */
const getCalendarISO = (value) => {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString().split("T")[0];
};

const TenantStatusBadge = ({ active, trialStartDate, trialEndsAt, accessBlockedAt }) => {
    let statusClass = "active";
    let statusLabel = "Ativo";
    const todayISO = new Date().toLocaleDateString("en-CA");
    const startDate = getCalendarISO(trialStartDate);
    const endDate = getCalendarISO(trialEndsAt);

    if (accessBlockedAt || active === false) {
        statusClass = "blocked";
        statusLabel = "Bloqueado";
    } else if (endDate) {
        if (startDate && startDate > todayISO) {
            statusClass = "pending";
            statusLabel = "Trial Agendado";
        } else if (endDate < todayISO) {
            statusClass = "expired";
            statusLabel = "Trial Expirado";
        } else {
            statusClass = "trial";
            statusLabel = "Trial";
        }
    }

    return (
        <span className={`tenant-status-badge ${statusClass}`}>
            {statusLabel}
        </span>
    );
};

/**
 * PaymentStatusBadge — Badge visual para status de pagamento.
 */
export const PaymentStatusBadge = ({ status }) => {
    const statusMap = {
        approved: "Aprovado",
        pending: "Pendente",
        rejected: "Rejeitado",
        in_process: "Processando",
        cancelled: "Cancelado",
        refunded: "Reembolsado",
        charged_back: "Chargeback",
    };

    const label = statusMap[status] || status || "—";
    const safeClass = (status || "").replace(/_/g, "_");

    return (
        <span className={`payment-status-badge ${safeClass}`}>
            {label}
        </span>
    );
};

export default TenantStatusBadge;
